import React from 'react';
import EinstellungenSeitenKopf from '../components';
import AllServicesTable from './components/AllServicesTable';

function ServicesPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Leistungen" />
      <AllServicesTable />
    </>
  );
}

export default ServicesPage;
